import React from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Input from '@amzn/meridian/input';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import trashTokens from '@amzn/meridian-tokens/base/icon/trash';
import Text from '@amzn/meridian/text';
import { LineState } from 'src/pages/settings/tabs/siteLayout/types';
import WorkstationChipList from './WorkstationChipList';

export interface LineCardProps {
  line: LineState;
  processPathIndex: number;
  lineIndex: number;
  onDelete: (lineIndex: number) => void;
  onLineNameChange: (lineIndex: number, name: string) => void;
}

const LineCard: React.FC<LineCardProps> = ({
  line,
  processPathIndex,
  lineIndex,
  onDelete,
  onLineNameChange,
}) => {
  const handleNameChange = (value: string) => {
    onLineNameChange(lineIndex, value);
  };

  const handleDelete = () => {
    onDelete(lineIndex);
  };

  const lineNameError = (!line.lineName || line.lineName.trim() === '') ? 'Line name is required' : undefined;

  return (
    <Box type="outline" spacingInset="300" minWidth={180}>
      <Column spacing="300">
        <Input
          value={line.lineName}
          onChange={handleNameChange}
          placeholder="Line name"
          label="Line name"
          size="small"
          error={!!lineNameError}
          errorMessage={lineNameError}
        />

        <Text type="b200" color="secondary">
          # Workstations: {line.workstations.length}
        </Text>

        <WorkstationChipList
          workstations={line.workstations}
          processPathIndex={processPathIndex}
          lineIndex={lineIndex}
        />

        <Row alignmentHorizontal="end">
          <Button type="icon" onClick={handleDelete} label="Delete line">
            <Icon tokens={trashTokens} />
          </Button>
        </Row>
      </Column>
    </Box>
  );
};

export default LineCard;
